import { RecoilState, RecoilValueReadOnly, selector } from 'recoil';
import { ValidationState } from '../../../types';
import { submissionAttemptedState as checkoutSubmissionAttempted } from '../../atoms';

export const validator = <T>(
	validationState: RecoilValueReadOnly<T>,
	submissionAttemptedState?: RecoilState<boolean>
): RecoilValueReadOnly<ValidationState<T>> =>
	selector<ValidationState<T>>({
		key: `${validationState.key}WithTouched`,
		get({ get }) {
			const submissionAttempted = get(
				submissionAttemptedState ?? checkoutSubmissionAttempted
			);
			const validation = get(validationState);

			return {
				validation,
				ignoreTouched: submissionAttempted
			};
		}
	});
